export default __webpack_public_path__ + "static/sep22-417cb8781975a5f6bd5dcac313f6dc6f.png";